import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { About } from './pages/About';
import { Experiences } from './pages/Experiences';
import { Achievements } from './pages/Achievements';
import { Contributions } from './pages/Contributions';
import { Contacts } from './pages/Contacts';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<About data-id="element-5" />} data-id="element-4" />
          <Route path="experiences" element={<Experiences data-id="element-7" />} data-id="element-6" />
          <Route path="achievements" element={<Achievements data-id="element-9" />} data-id="element-8" />
          <Route path="contributions" element={<Contributions data-id="element-11" />} data-id="element-10" />
          <Route path="contacts" element={<Contacts data-id="element-13" />} data-id="element-12" />
        </Route>
      </Routes>
    </BrowserRouter>;
}